import {normalize, schema, denormalize} from 'normalizr';

const producto = new schema.Entity('productos', {}, {idAttribute: "id"});

export function normalizeDatos(myData) {

    const mySchema = {productos: [producto]};
    const normalizedData = normalize(myData, mySchema);
    return normalizedData;
}


export function normalizeDato(myData) {

    const mySchema = producto;
    const normalizedData = normalize(myData, mySchema);

    return normalizedData;
}

export function denormalizeDato(myData, store) {

    const mySchema = producto;

    const normalizedData = denormalize(myData, mySchema, store);

    return normalizedData;
}

export default producto;
